module.exports = __webpack_public_path__ + "static/media/plus.db8a21aa.svg";